export const InstitucionesPublicasNumero = [
    {text: 'Academia de las Lenguas Mayas de Guatemala (ALMG)', value: '1'},
    {text: 'Agencia Nacional de Alianzas para el Desarrollo de Infraestructura Económica (Anadie)', value: '2'},
    {text: 'Aporte para la Descentralización Cultural (Adesca)', value: '3'},
    {text: 'Asociación de Desarrollo Integral de Municipalidades del Altiplano Marquense (ADIMAM)', value: '4'},
    {text: 'Asociación de Municipios en el Corazón de la Zona Paz (Municopaz)', value: '5'},
    {text: 'Asociación de Pentatlón Moderno', value: '6'},
    {text: 'Asociación Deportiva Nacional de Billar', value: '7'},
    {text: 'Asociación Deportiva Nacional de Hockey', value: '8'},
    {text: 'Asociación Deportiva Nacional de Polo', value: '9'},
    {text: 'Asociación Deportiva Nacional de Softbol', value: '10'},
    {text: 'Asociación Deportiva Nacional de Surf', value: '11'},
    {text: 'Asociación Deportiva Nacional de Tiro con Arco', value: '12'},
    {text: 'Asociación Guatemalteca de Rugby', value: '13'},
    {text: 'Asociación Nacional de  Tiro con Arma de Caza', value: '14'},
    {text: 'Asociación Nacional de Ecuestres de Guatemala', value: '15'},
    {text: 'Asociación Nacional de Golf', value: '16'},
    {text: 'Asociación Nacional de Municipalidades (Anam)', value: '17'},
    {text: 'Asociación Nacional de Navegación a Vela', value: '18'},
    {text: 'Asociación Nacional de Paracaidismo Deportivo', value: '19'},
    {text: 'Asociación Nacional de Pesca Deportiva', value: '20'},
    {text: 'Asociación Nacional de Raquetbol', value: '21'},
    {text: 'Asociación Nacional de Squash', value: '22'},
    {text: 'Asociación Nacional de Vuelo Libre', value: '23'},
    {text: 'Autoridad para el Manejo Sustentable de la Cuenca del Lago de Atitlán y su Entorno (AMSCLAE)', value: '24'},
    {text: 'Autoridad para el Manejo Sustentable de la Cuenca y del Lago de Amatitlán (AMSA)', value: '25'},
    {text: 'Banco de Guatemala (Banguat)', value: '26'},
    {text: 'Benemérito Cuerpo Voluntario de Bomberos de Guatemala (CVB)', value: '27'},
    {text: 'Comisión Presidencial Contra la Discriminación y el Racismo Contra los Pueblos Indígenas (CODISRA)', value: '28'},
    {text: 'Comisión Presidencial para la Paz y los Derechos Humanos (COPADEH)', value: '29'},
    {text: 'Comité Nacional de Alfabetización (Conalfa)', value: '30'},
    {text: 'Comité Olímpico Guatemalteco (COG)', value: '31'},
    {text: 'Comité Permanente de Exposiciones (Coperex)', value: '32'},
    {text: 'Confederación Deportiva Autónoma de Guatemala (CDAG)', value: '33'},
    {text: 'Congreso de la República de Guatemala', value: '34'},
    {text: 'Consejo de Departamental de Desarrollo - 1', value: '35'},
    {text: 'Consejo de Departamental de Desarrollo - 10', value: '36'},
    {text: 'Consejo de Departamental de Desarrollo - 11', value: '37'},
    {text: 'Consejo de Departamental de Desarrollo - 12', value: '38'},
    {text: 'Consejo de Departamental de Desarrollo - 13', value: '39'},
    {text: 'Consejo de Departamental de Desarrollo - 14', value: '40'},
    {text: 'Consejo de Departamental de Desarrollo - 15', value: '41'},
    {text: 'Consejo de Departamental de Desarrollo - 16', value: '42'},
    {text: 'Consejo de Departamental de Desarrollo - 17', value: '43'},
    {text: 'Consejo de Departamental de Desarrollo - 18', value: '44'},
    {text: 'Consejo de Departamental de Desarrollo - 19', value: '45'},
    {text: 'Consejo de Departamental de Desarrollo - 2', value: '46'},
    {text: 'Consejo de Departamental de Desarrollo - 20', value: '47'},
    {text: 'Consejo de Departamental de Desarrollo - 21', value: '48'},
    {text: 'Consejo de Departamental de Desarrollo - 22', value: '49'},
    {text: 'Consejo de Departamental de Desarrollo - 3', value: '50'},
    {text: 'Consejo de Departamental de Desarrollo - 4', value: '51'},
    {text: 'Consejo de Departamental de Desarrollo - 5', value: '52'},
    {text: 'Consejo de Departamental de Desarrollo - 6', value: '53'},
    {text: 'Consejo de Departamental de Desarrollo - 7', value: '54'},
    {text: 'Consejo de Departamental de Desarrollo - 8', value: '55'},
    {text: 'Consejo de Departamental de Desarrollo - 9', value: '56'},
    {text: 'Consejo de Nacional de Desarrollo Urbano y Rural', value: '57'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -1', value: '58'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -2', value: '59'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -3', value: '60'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -4', value: '61'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -5', value: '62'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -6', value: '63'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -7', value: '64'},
    {text: 'Consejo de Regional de Desarrollo Urbano y Rural -8', value: '65'},
    {text: 'Consejo Económico y Social de Guatemala (CES)', value: '66'},
    {text: 'Consejo Nacional de Adopciones (CNA)', value: '67'},
    {text: 'Consejo Nacional de Áreas Protegidas (CONAP)', value: '68'},
    {text: 'Consejo Nacional de Atención al Migrante de Guatemala (Conamigua)', value: '69'},
    {text: 'Consejo Nacional de la Juventud (Conjuve)', value: '70'},
    {text: 'Consejo Nacional del Deporte, la Educación Física y la Recreación (Conader)', value: '71'},
    {text: 'Consejo Nacional para la Atención de las Personas con Discapacidad (Conadi)', value: '72'},
    {text: 'Consejo Nacional para la Protección de la Antigua Guatemala (CNPAG)', value: '73'},
    {text: 'Contraloría General de Cuentas (CGC)', value: '74'},
    {text: 'Coordinadora Nacional para la Reducción de Desastres de Origen Natural o Provocado  (Conred)', value: '75'},
    {text: 'Corporación Financiera Nacional (Corfina)', value: '76'},
    {text: 'Corte de Constitucionalidad (CC)', value: '77'},
    {text: 'Defensoría de la Mujer Indígena (DEMI)', value: '78'},
    {text: 'El Crédito Hipotecario Nacional de Guatemala  (CHN)', value: '79'},
    {text: 'Empresa Eléctrica de Gualán', value: '80'},
    {text: 'Empresa Eléctrica Municipal de Huehuetenango', value: '81'},
    {text: 'Empresa Eléctrica Municipal de Jalapa', value: '82'},
    {text: 'Empresa Eléctrica Municipal de Puerto Barrios', value: '83'},
    {text: 'Empresa Eléctrica Municipal de San Pedro Pinula', value: '84'},
    {text: 'Empresa Eléctrica Municipal de Zacapa', value: '85'},
    {text: 'Empresa Ferrocarriles de Guatemala (Fegua)', value: '86'},
    {text: 'Empresa Guatemalteca de Telecomunicaciones (Guatel)', value: '87'},
    {text: 'Empresa Hidroeléctrica Municipal de El Progreso', value: '88'},
    {text: 'Empresa Hidroeléctrica Municipal de Retalhuleu', value: '89'},
    {text: 'Empresa Metropolitana de Vivienda y Desarrollo Urbano', value: '90'},
    {text: 'Empresa Municipal de Agua (Empagua)', value: '91'},
    {text: 'Empresa Municipal de Agua Potable y Alcantarillado (Emapet), Flores-San Benito, Petén', value: '92'},
    {text: 'Empresa Municipal de Transporte de la Ciudad de Guatemala', value: '93'},
    {text: 'Empresa Municipal Rural de Electricidad Ixcán (EMRE)', value: '94'},
    {text: 'Empresa Portuaria Nacional de Champerico (EPNCH)', value: '95'},
    {text: 'Empresa Portuaria Nacional Santo Tomás de Castilla (Empornac)', value: '96'},
    {text: 'Empresa Portuaria Quetzal  (EPQ)', value: '97'},
    {text: 'Entidad Metropolitana Reguladora de Transporte y Tránsito del Municipio de Guatemala y sus Áreas de Influencia Urbana', value: '98'},
    {text: 'Escuela Nacional Central de Agricultura (ENCA)', value: '99'},
    {text: 'Federación Nacional de Ajedrez de Guatemala', value: '100'},
    {text: 'Federación Nacional de Andinismo', value: '101'},
    {text: 'Federación Nacional de Atletismo', value: '102'},
    {text: 'Federación Nacional de Bádminton de Guatemala', value: '103'},
    {text: 'Federación Nacional de Baloncesto', value: '104'},
    {text: 'Federación Nacional de Balonmano', value: '105'},
    {text: 'Federación Nacional de Beisbol', value: '106'},
    {text: 'Federación Nacional de Boliche', value: '107'},
    {text: 'Federación Nacional de Boxeo', value: '108'},
    {text: 'Federación Nacional de Ciclismo de Guatemala', value: '109'},
    {text: 'Federación Nacional de Esgrima', value: '110'},
    {text: 'Federación Nacional de Fisicoculturismo de Guatemala', value: '111'},
    {text: 'Federación Nacional de Fútbol', value: '112'},
    {text: 'Federación Nacional de Gimnasia', value: '113'},
    {text: 'Federación Nacional de Judo', value: '114'},
    {text: 'Federación Nacional de Karate Do', value: '115'},
    {text: 'Federación Nacional de Levantamiento de Pesas', value: '116'},
    {text: 'Federación Nacional de Levantamiento de Potencia', value: '117'},
    {text: 'Federación Nacional de Luchas de Guatemala', value: '118'},
    {text: 'Federación Nacional de Motociclismo', value: '119'},
    {text: 'Federación Nacional de Natación, Clavados, Polo Acuático y Nado Sincronizado', value: '120'},
    {text: 'Federación Nacional de Patinaje sobre Ruedas', value: '121'},
    {text: 'Federación Nacional de Remo y Canotaje de Guatemala', value: '122'},
    {text: 'Federación Nacional de Tae Kwon Do', value: '123'},
    {text: 'Federación Nacional de Tenis de Campo', value: '124'},
    {text: 'Federación Nacional de Tenis de Mesa', value: '125'},
    {text: 'Federación Nacional de Tiro', value: '126'},
    {text: 'Federación Nacional de Triatlón', value: '127'},
    {text: 'Federación Nacional de Voleibol', value: '128'},
    {text: 'Fondo de Desarrollo Indígena Guatemalteco', value: '129'},
    {text: 'Fondo de Tierras (Fontierras)', value: '130'},
    {text: 'Inspección General de Cooperativas (Ingecop)', value: '132'},
    {text: 'Instituto de Ciencia y Tecnología Agrícolas (ICTA)', value: '133'},
    {text: 'Instituto de Fomento de Hipotecas Aseguradas (FHA)', value: '134'},
    {text: 'Instituto de Fomento Municipal  (Infom)', value: '135'},
    {text: 'Instituto de la Defensa Pública Penal (IDPP)', value: '136'},
    {text: 'Instituto de Previsión Militar (IPM)', value: '137'},
    {text: 'Instituto de Recreación de los Trabajadores de la Empresa Privada de Guatemala (Irtra)', value: '138'},
    {text: 'Instituto Guatemalteco de Seguridad Social (IGSS)', value: '139'},
    {text: 'Instituto Guatemalteco de Turismo (Inguat)', value: '140'},
    {text: 'Instituto Nacional de Administración Pública (INAP)', value: '141'},
    {text: 'Instituto Nacional de Bosques (Inab)', value: '142'},
    {text: 'Instituto Nacional de Ciencias Forenses de Guatemala (Inacif)', value: '143'},
    {text: 'Instituto Nacional de Comercialización Agrícola (Indeca)', value: '144'},
    {text: 'Instituto Nacional de Cooperativas (Inacop)', value: '145'},
    {text: 'Instituto Nacional de Electrificación (INDE)', value: '146'},
    {text: 'Instituto Nacional de Estadística (INE)', value: '147'},
    {text: 'Instituto Técnico de Capacitación y Productividad (Intecap)', value: '148'},
    {text: 'Mancomunidad  de  Municipios  del  Sur  Occidente  de Huehuetenango', value: '149'},
    {text: 'Mancomunidad  de  Municipios  Kakchiquel,  Chichoy  y Atitlán (Mankatitlán)', value: '150'},
    {text: 'Mancomunidad  Encuentro  Regional  Ixil  por  la  Paz (Eripaz)', value: '151'},
    {text: 'Mancomunidad Área Mam de Quetzaltenango (Mamq)', value: '152'},
    {text: 'Mancomunidad de  Municipalidades de  la Cuenca del Río El Naranjo (Mancuerna)', value: '153'},
    {text: 'Mancomunidad de Municipios de Desarrollo Integral de la Cuenca Copan Ch’orti’', value: '154'},
    {text: 'Mancomunidad de Municipios de la Franja Transversal del Norte', value: '155'},
    {text: 'Mancomunidad de municipios del Polochic e Izabal, MANPOLIZA', value: '156'},
    {text: 'Mancomunidad de Municipios del Valle de Baja Verapaz, MANCOVALLE  ', value: '157'},
    {text: 'Mancomunidad de Municipios Metrópoli de los Altos', value: '158'},
    {text: 'Mancomunidad de Municipios para el Desarrollo Integral del Área Poqomchí (Manpoqomchi)', value: '159'},
    {text: 'Mancomunidad de Nor-Oriente', value: '160'},
    {text: 'Mancomunidad del Cono Sur, Jutiapa', value: '161'},
    {text: 'Mancomunidad del Sur Oriente', value: '162'},
    {text: 'Mancomunidad Frontera del Norte', value: '163'},
    {text: 'Mancomunidad Gran Ciudad del Sur del Departamento de Guatemala', value: '164'},
    {text: 'Mancomunidad Huista', value: '165'},
    {text: 'Mancomunidad Laguna Güija', value: '166'},
    {text: 'Mancomunidad Montaña El Gigante', value: '167'},
    {text: 'Mancomunidad Trinacional Fronteriza Río Lempa', value: '168'},
    {text: 'Mancomunidad Tzolojya', value: '169'},
    {text: 'Ministerio de Agricultura, Ganadería y Alimentación', value: '170'},
    {text: 'Ministerio de Ambiente y Recursos Naturales', value: '171'},
    {text: 'Ministerio de Comunicaciones, Infraestructura y Vivienda', value: '172'},
    {text: 'Ministerio de Cultura y Deportes', value: '173'},
    {text: 'Ministerio de Desarrollo Social', value: '174'},
    {text: 'Ministerio de Economía', value: '175'},
    {text: 'Ministerio de Educación', value: '176'},
    {text: 'Ministerio de Energía y Minas', value: '177'},
    {text: 'Ministerio de Finanzas Públicas', value: '178'},
    {text: 'Ministerio de Gobernación', value: '179'},
    {text: 'Ministerio de la Defensa Nacional', value: '180'},
    {text: 'Ministerio de Relaciones Exteriores', value: '181'},
    {text: 'Ministerio de Salud Pública y Asistencia Social', value: '182'},
    {text: 'Ministerio de Trabajo y Previsión Social', value: '183'},
    {text: 'Ministerio Público (MP)', value: '184'},
    {text: 'Municipalidad de Acatenango', value: '185'},
    {text: 'Municipalidad de Agua Blanca', value: '186'},
    {text: 'Municipalidad de Aguacatán', value: '187'},
    {text: 'Municipalidad de Almolonga', value: '188'},
    {text: 'Municipalidad de Alotenango', value: '189'},
    {text: 'Municipalidad de Amatitlán', value: '190'},
    {text: 'Municipalidad de Antigua Guatemala', value: '191'},
    {text: 'Municipalidad de Asunción Mita', value: '192'},
    {text: 'Municipalidad de Atescatempa', value: '193'},
    {text: 'Municipalidad de Ayutla', value: '194'},
    {text: 'Municipalidad de Barberena', value: '195'},
    {text: 'Municipalidad de Barillas', value: '196'},
    {text: 'Municipalidad de Cabañas', value: '197'},
    {text: 'Municipalidad de Cabricán', value: '198'},
    {text: 'Municipalidad de Cahabón', value: '199'},
    {text: 'Municipalidad de Cajolá', value: '200'},
    {text: 'Municipalidad de Camotán', value: '201'},
    {text: 'Municipalidad de Canillá', value: '202'},
    {text: 'Municipalidad de Cantel', value: '203'},
    {text: 'Municipalidad de Casillas', value: '204'},
    {text: 'Municipalidad de Catarina', value: '205'},
    {text: 'Municipalidad de Chahal', value: '206'},
    {text: 'Municipalidad de Chajul', value: '207'},
    {text: 'Municipalidad de Champerico', value: '208'},
    {text: 'Municipalidad de Chiantla', value: '209'},
    {text: 'Municipalidad de Chicacao', value: '210'},
    {text: 'Municipalidad de Chicamán', value: '211'},
    {text: 'Municipalidad de Chiché', value: '212'},
    {text: 'Municipalidad de Chichicastenango', value: '213'},
    {text: 'Municipalidad de Chimaltenango', value: '214'},
    {text: 'Municipalidad de Chinautla', value: '215'},
    {text: 'Municipalidad de Chinique', value: '216'},
    {text: 'Municipalidad de Chiquimula', value: '217'},
    {text: 'Municipalidad de Chiquimulilla', value: '218'},
    {text: 'Municipalidad de Chisec', value: '219'},
    {text: 'Municipalidad de Chuarrancho', value: '220'},
    {text: 'Municipalidad de Ciudad Vieja', value: '221'},
    {text: 'Municipalidad de Coatepeque', value: '222'},
    {text: 'Municipalidad de Cobán', value: '223'},
    {text: 'Municipalidad de Colomba', value: '224'},
    {text: 'Municipalidad de Colotenango', value: '225'},
    {text: 'Municipalidad de Comalapa', value: '226'},
    {text: 'Municipalidad de Comapa', value: '227'},
    {text: 'Municipalidad de Comitancillo', value: '228'},
    {text: 'Municipalidad de Concepción', value: '229'},
    {text: 'Municipalidad de Concepción Chiquirichapa', value: '230'},
    {text: 'Municipalidad de Concepción Huista', value: '231'},
    {text: 'Municipalidad de Concepción Las Minas', value: '232'},
    {text: 'Municipalidad de Concepción Tutuapa', value: '233'},
    {text: 'Municipalidad de Conguaco', value: '234'},
    {text: 'Municipalidad de Cubulco', value: '235'},
    {text: 'Municipalidad de Cuilapa', value: '236'},
    {text: 'Municipalidad de Cuilco', value: '237'},
    {text: 'Municipalidad de Cunén', value: '238'},
    {text: 'Municipalidad de Cuyotenango', value: '239'},
    {text: 'Municipalidad de Dolores', value: '240'},
    {text: 'Municipalidad de El Adelanto', value: '241'},
    {text: 'Municipalidad de El Asintal', value: '242'},
    {text: 'Municipalidad de El Chal ', value: '243'},
    {text: 'Municipalidad de El Chol', value: '244'},
    {text: 'Municipalidad de El Estor', value: '245'},
    {text: 'Municipalidad de El Jícaro', value: '246'},
    {text: 'Municipalidad de El Palmar', value: '247'},
    {text: 'Municipalidad de El Progreso', value: '248'},
    {text: 'Municipalidad de El Quetzal', value: '249'},
    {text: 'Municipalidad de El Rodeo', value: '250'},
    {text: 'Municipalidad de El Tejar', value: '251'},
    {text: 'Municipalidad de El Tumbador', value: '252'},
    {text: 'Municipalidad de Escuintla', value: '253'},
    {text: 'Municipalidad de Esquipulas', value: '254'},
    {text: 'Municipalidad de Esquipulas Palo Gordo', value: '255'},
    {text: 'Municipalidad de Estanzuela', value: '256'},
    {text: 'Municipalidad de Flores', value: '257'},
    {text: 'Municipalidad de Flores Costa Cuca', value: '258'},
    {text: 'Municipalidad de Fraijanes', value: '259'},
    {text: 'Municipalidad de Fray Bartolomé de las Casas', value: '260'},
    {text: 'Municipalidad de Génova', value: '261'},
    {text: 'Municipalidad de Granados', value: '262'},
    {text: 'Municipalidad de Gualán', value: '263'},
    {text: 'Municipalidad de Guanagazapa', value: '264'},
    {text: 'Municipalidad de Guastatoya', value: '265'},
    {text: 'Municipalidad de Guatemala', value: '266'},
    {text: 'Municipalidad de Guazacapán', value: '267'},
    {text: 'Municipalidad de Huehuetenango', value: '268'},
    {text: 'Municipalidad de Huitán', value: '269'},
    {text: 'Municipalidad de Huité', value: '270'},
    {text: 'Municipalidad de Ipala', value: '271'},
    {text: 'Municipalidad de Ixcán', value: '272'},
    {text: 'Municipalidad de Ixchiguán', value: '273'},
    {text: 'Municipalidad de Iztapa', value: '274'},
    {text: 'Municipalidad de Jacaltenango', value: '275'},
    {text: 'Municipalidad de Jalapa', value: '276'},
    {text: 'Municipalidad de Jalpatagua', value: '277'},
    {text: 'Municipalidad de Jerez', value: '278'},
    {text: 'Municipalidad de Jocotán', value: '279'},
    {text: 'Municipalidad de Jocotenango', value: '280'},
    {text: 'Municipalidad de Joyabaj', value: '281'},
    {text: 'Municipalidad de Jutiapa', value: '282'},
    {text: 'Municipalidad de La Blanca', value: '283'},
    {text: 'Municipalidad de La Democracia Escuintla', value: '284'},
    {text: 'Municipalidad de La Democracia Huehuetenango', value: '285'},
    {text: 'Municipalidad de La Esperanza', value: '286'},
    {text: 'Municipalidad de La Gomera', value: '287'},
    {text: 'Municipalidad de La Libertad Huehuetenango', value: '288'},
    {text: 'Municipalidad de La Libertad Petén', value: '289'},
    {text: 'Municipalidad de La Reforma', value: '290'},
    {text: 'Municipalidad de La Unión', value: '291'},
    {text: 'Municipalidad de Lanquín', value: '292'},
    {text: 'Municipalidad de Las Cruces', value: '293'},
    {text: 'Municipalidad de Livingston', value: '294'},
    {text: 'Municipalidad de Los Amates', value: '295'},
    {text: 'Municipalidad de Magdalena Milpas Altas', value: '296'},
    {text: 'Municipalidad de Malacatán', value: '297'},
    {text: 'Municipalidad de Malacatancito', value: '298'},
    {text: 'Municipalidad de Masagua', value: '299'},
    {text: 'Municipalidad de Mataquescuintla', value: '300'},
    {text: 'Municipalidad de Mazatenango', value: '301'},
    {text: 'Municipalidad de Melchor de Mencos', value: '302'},
    {text: 'Municipalidad de Mixco', value: '303'},
    {text: 'Municipalidad de Momostenango', value: '304'},
    {text: 'Municipalidad de Monjas', value: '305'},
    {text: 'Municipalidad de Morales', value: '306'},
    {text: 'Municipalidad de Morazán', value: '307'},
    {text: 'Municipalidad de Moyuta', value: '308'},
    {text: 'Municipalidad de Nahualá', value: '309'},
    {text: 'Municipalidad de Nebaj', value: '310'},
    {text: 'Municipalidad de Nentón', value: '311'},
    {text: 'Municipalidad de Nueva Concepción', value: '312'},
    {text: 'Municipalidad de Nueva Santa Rosa', value: '313'},
    {text: 'Municipalidad de Nuevo Progreso', value: '314'},
    {text: 'Municipalidad de Nuevo San Carlos', value: '315'},
    {text: 'Municipalidad de Ocós', value: '316'},
    {text: 'Municipalidad de Olintepeque', value: '317'},
    {text: 'Municipalidad de Olopa', value: '318'},
    {text: 'Municipalidad de Oratorio', value: '319'},
    {text: 'Municipalidad de Pachalum', value: '320'},
    {text: 'Municipalidad de Pajapita', value: '321'},
    {text: 'Municipalidad de Palencia', value: '322'},
    {text: 'Municipalidad de Palestina de los Altos', value: '323'},
    {text: 'Municipalidad de Palín', value: '324'},
    {text: 'Municipalidad de Panajachel', value: '325'},
    {text: 'Municipalidad de Panzós', value: '326'},
    {text: 'Municipalidad de Parramos', value: '327'},
    {text: 'Municipalidad de Pasaco', value: '328'},
    {text: 'Municipalidad de Pastores', value: '329'},
    {text: 'Municipalidad de Patulul', value: '330'},
    {text: 'Municipalidad de Patzicía', value: '331'},
    {text: 'Municipalidad de Patzité', value: '332'},
    {text: 'Municipalidad de Patzún', value: '333'},
    {text: 'Municipalidad de Petapa', value: '334'},
    {text: 'Municipalidad de Petatán ', value: '335'},
    {text: 'Municipalidad de Pochuta', value: '336'},
    {text: 'Municipalidad de Poptún', value: '337'},
    {text: 'Municipalidad de Pueblo Nuevo', value: '338'},
    {text: 'Municipalidad de Pueblo Nuevo Viñas', value: '339'},
    {text: 'Municipalidad de Puerto Barrios', value: '340'},
    {text: 'Municipalidad de Purulhá', value: '341'},
    {text: 'Municipalidad de Quesada', value: '342'},
    {text: 'Municipalidad de Quetzaltenango', value: '343'},
    {text: 'Municipalidad de Quezaltepeque', value: '344'},
    {text: 'Municipalidad de Rabinal', value: '345'},
    {text: 'Municipalidad de Raxruhá', value: '346'},
    {text: 'Municipalidad de Retalhuleu', value: '347'},
    {text: 'Municipalidad de Río Blanco', value: '348'},
    {text: 'Municipalidad de Río Bravo', value: '349'},
    {text: 'Municipalidad de Río Hondo', value: '350'},
    {text: 'Municipalidad de Sacapulas', value: '351'},
    {text: 'Municipalidad de Salamá', value: '352'},
    {text: 'Municipalidad de Salcajá', value: '353'},
    {text: 'Municipalidad de Samayac', value: '354'},
    {text: 'Municipalidad de San Agustín Acasaguastlán', value: '355'},
    {text: 'Municipalidad de San Andrés', value: '356'},
    {text: 'Municipalidad de San Andrés Itzapa', value: '357'},
    {text: 'Municipalidad de San Andrés Sajcabajá', value: '358'},
    {text: 'Municipalidad de San Andrés Semetabaj', value: '359'},
    {text: 'Municipalidad de San Andrés Villa Seca', value: '360'},
    {text: 'Municipalidad de San Andrés Xecul', value: '361'},
    {text: 'Municipalidad de San Antonio Aguas Calientes', value: '362'},
    {text: 'Municipalidad de San Antonio Huista', value: '363'},
    {text: 'Municipalidad de San Antonio Ilotenango', value: '364'},
    {text: 'Municipalidad de San Antonio La Paz', value: '365'},
    {text: 'Municipalidad de San Antonio Palopó', value: '366'},
    {text: 'Municipalidad de San Antonio Sacatepéquez', value: '367'},
    {text: 'Municipalidad de San Antonio Suchitepéquez', value: '368'},
    {text: 'Municipalidad de San Bartolo Aguas Calientes', value: '369'},
    {text: 'Municipalidad de San Bartolomé Jocotenango', value: '370'},
    {text: 'Municipalidad de San Bartolomé Milpas Altas', value: '371'},
    {text: 'Municipalidad de San Benito', value: '372'},
    {text: 'Municipalidad de San Bernardino', value: '373'},
    {text: 'Municipalidad de San Carlos Alzatate', value: '374'},
    {text: 'Municipalidad de San Carlos Sija', value: '375'},
    {text: 'Municipalidad de San Cristóbal Acasaguastlán', value: '376'},
    {text: 'Municipalidad de San Cristóbal Cucho', value: '377'},
    {text: 'Municipalidad de San Cristóbal Totonicapán', value: '378'},
    {text: 'Municipalidad de San Cristóbal Verapaz', value: '379'},
    {text: 'Municipalidad de San Diego', value: '380'},
    {text: 'Municipalidad de San Felipe', value: '381'},
    {text: 'Municipalidad de San Francisco', value: '382'},
    {text: 'Municipalidad de San Francisco El Alto', value: '383'},
    {text: 'Municipalidad de San Francisco La Unión', value: '384'},
    {text: 'Municipalidad de San Francisco Zapotitlán', value: '385'},
    {text: 'Municipalidad de San Gabriel', value: '386'},
    {text: 'Municipalidad de San Gaspar Ixchil', value: '387'},
    {text: 'Municipalidad de San Ildefonso Ixtahuacán', value: '388'},
    {text: 'Municipalidad de San Jacinto', value: '389'},
    {text: 'Municipalidad de San Jerónimo', value: '390'},
    {text: 'Municipalidad de San Jorge', value: '391'},
    {text: 'Municipalidad de San José Escuintla', value: '392'},
    {text: 'Municipalidad de San José Pentén', value: '393'},
    {text: 'Municipalidad de San José Acatempa', value: '394'},
    {text: 'Municipalidad de San José Chacayá', value: '395'},
    {text: 'Municipalidad de San José del Golfo', value: '396'},
    {text: 'Municipalidad de San José El Ídolo', value: '397'},
    {text: 'Municipalidad de San José La Arada', value: '398'},
    {text: 'Municipalidad de San José la Máquina', value: '399'},
    {text: 'Municipalidad de San José Ojetenam', value: '400'},
    {text: 'Municipalidad de San José Pinula', value: '401'},
    {text: 'Municipalidad de San José Poaquil', value: '402'},
    {text: 'Municipalidad de San Juan Atitán', value: '403'},
    {text: 'Municipalidad de San Juan Bautista', value: '404'},
    {text: 'Municipalidad de San Juan Chamelco', value: '405'},
    {text: 'Municipalidad de San Juan Cotzal', value: '406'},
    {text: 'Municipalidad de San Juan Ermita', value: '407'},
    {text: 'Municipalidad de San Juan Ixcoy', value: '408'},
    {text: 'Municipalidad de San Juan La Laguna', value: '409'},
    {text: 'Municipalidad de San Juan Ostuncalco', value: '410'},
    {text: 'Municipalidad de San Juan Sacatepéquez', value: '411'},
    {text: 'Municipalidad de San Juan Tecuaco', value: '412'},
    {text: 'Municipalidad de San Lorenzo Suchitepéquez', value: '413'},
    {text: 'Municipalidad de San Lorenzo San Marcos', value: '414'},
    {text: 'Municipalidad de San Lucas Sacatepéquez', value: '415'},
    {text: 'Municipalidad de San Lucas Tolimán', value: '416'},
    {text: 'Municipalidad de San Luis', value: '417'},
    {text: 'Municipalidad de San Luis Jilotepeque', value: '418'},
    {text: 'Municipalidad de San Manuel Chaparrón', value: '419'},
    {text: 'Municipalidad de San Marcos', value: '420'},
    {text: 'Municipalidad de San Marcos La Laguna', value: '421'},
    {text: 'Municipalidad de San Martín Jilotepeque', value: '422'},
    {text: 'Municipalidad de San Martín Sacatepéquez', value: '423'},
    {text: 'Municipalidad de San Martín Zapotitlán', value: '424'},
    {text: 'Municipalidad de San Mateo', value: '425'},
    {text: 'Municipalidad de San Mateo Ixtatán', value: '426'},
    {text: 'Municipalidad de San Miguel Acatán', value: '427'},
    {text: 'Municipalidad de San Miguel Chicaj', value: '428'},
    {text: 'Municipalidad de San Miguel Dueñas', value: '429'},
    {text: 'Municipalidad de San Miguel Ixtahuacán', value: '430'},
    {text: 'Municipalidad de San Miguel Panan', value: '431'},
    {text: 'Municipalidad de San Miguel Sigüilá', value: '432'},
    {text: 'Municipalidad de San Pablo', value: '433'},
    {text: 'Municipalidad de San Pablo Jocopilas', value: '434'},
    {text: 'Municipalidad de San Pablo La Laguna', value: '435'},
    {text: 'Municipalidad de San Pedro Ayampuc', value: '436'},
    {text: 'Municipalidad de San Pedro Carchá', value: '437'},
    {text: 'Municipalidad de San Pedro Jocopilas', value: '438'},
    {text: 'Municipalidad de San Pedro La Laguna', value: '439'},
    {text: 'Municipalidad de San Pedro Necta', value: '440'},
    {text: 'Municipalidad de San Pedro Pinula', value: '441'},
    {text: 'Municipalidad de San Pedro Sacatepéquez Guatemala', value: '442'},
    {text: 'Municipalidad de San Pedro Sacatepéquez San Marcos', value: '443'},
    {text: 'Municipalidad de San Rafael La Independencia', value: '444'},
    {text: 'Municipalidad de San Rafael Las Flores', value: '445'},
    {text: 'Municipalidad de San Rafael Pétzal', value: '446'},
    {text: 'Municipalidad de San Rafael Pie de la Cuesta', value: '447'},
    {text: 'Municipalidad de San Raimundo', value: '448'},
    {text: 'Municipalidad de San Sebastián', value: '449'},
    {text: 'Municipalidad de San Sebastián Coatán', value: '450'},
    {text: 'Municipalidad de San Sebastián Huehuetenango', value: '451'},
    {text: 'Municipalidad de San Vicente Pacaya', value: '452'},
    {text: 'Municipalidad de Sanarate', value: '453'},
    {text: 'Municipalidad de Sansare', value: '454'},
    {text: 'Municipalidad de Santa Ana', value: '455'},
    {text: 'Municipalidad de Santa Ana Huista', value: '456'},
    {text: 'Municipalidad de Santa Apolonia', value: '457'},
    {text: 'Municipalidad de Santa Bárbara Suchitepéquez', value: '458'},
    {text: 'Municipalidad de Santa Bárbara Huehuetenango', value: '459'},
    {text: 'Municipalidad de Santa Catalina La Tinta', value: '460'},
    {text: 'Municipalidad de Santa Catarina Barahona', value: '461'},
    {text: 'Municipalidad de Santa Catarina Ixtahuacán', value: '462'},
    {text: 'Municipalidad de Santa Catarina Mita', value: '463'},
    {text: 'Municipalidad de Santa Catarina Palopó', value: '464'},
    {text: 'Municipalidad de Santa Catarina Pinula', value: '465'},
    {text: 'Municipalidad de Santa Clara La Laguna', value: '466'},
    {text: 'Municipalidad de Santa Cruz Balanyá', value: '467'},
    {text: 'Municipalidad de Santa Cruz del Quiché', value: '468'},
    {text: 'Municipalidad de Santa Cruz La Laguna', value: '469'},
    {text: 'Municipalidad de Santa Cruz Muluá', value: '470'},
    {text: 'Municipalidad de Santa Cruz Naranjo', value: '471'},
    {text: 'Municipalidad de Santa Cruz Verapaz', value: '472'},
    {text: 'Municipalidad de Santa Eulalia', value: '473'},
    {text: 'Municipalidad de Santa Lucía Cotzumalguapa', value: '474'},
    {text: 'Municipalidad de Santa Lucía La Reforma', value: '475'},
    {text: 'Municipalidad de Santa Lucía Milpas Altas', value: '476'},
    {text: 'Municipalidad de Santa Lucía Utatlán', value: '477'},
    {text: 'Municipalidad de Santa María Chiquimula', value: '478'},
    {text: 'Municipalidad de Santa María de Jesús', value: '479'},
    {text: 'Municipalidad de Santa María Ixhuatán', value: '480'},
    {text: 'Municipalidad de Santa María Visitación', value: '481'},
    {text: 'Municipalidad de Santa Rosa de Lima', value: '482'},
    {text: 'Municipalidad de Santiago Atitlán', value: '483'},
    {text: 'Municipalidad de Santiago Chimaltenango', value: '484'},
    {text: 'Municipalidad de Santiago Sacatepéquez', value: '485'},
    {text: 'Municipalidad de Santo Domingo Suchitepéquez', value: '486'},
    {text: 'Municipalidad de Santo Domingo Xenacoj', value: '487'},
    {text: 'Municipalidad de Santo Tomás La Unión', value: '488'},
    {text: 'Municipalidad de Sayaxché', value: '489'},
    {text: 'Municipalidad de Senahú', value: '490'},
    {text: 'Municipalidad de Sibilia', value: '491'},
    {text: 'Municipalidad de Sibinal', value: '492'},
    {text: 'Municipalidad de Sipacapa', value: '493'},
    {text: 'Municipalidad de Sipacate', value: '494'},
    {text: 'Municipalidad de Siquinalá', value: '495'},
    {text: 'Municipalidad de Sololá', value: '496'},
    {text: 'Municipalidad de Soloma', value: '497'},
    {text: 'Municipalidad de Sumpango', value: '498'},
    {text: 'Municipalidad de Tacaná', value: '499'},
    {text: 'Municipalidad de Tactic', value: '500'},
    {text: 'Municipalidad de Tajumulco', value: '501'},
    {text: 'Municipalidad de Tamahú', value: '502'},
    {text: 'Municipalidad de Taxisco', value: '503'},
    {text: 'Municipalidad de Tecpán Guatemala', value: '504'},
    {text: 'Municipalidad de Tectitán', value: '505'},
    {text: 'Municipalidad de Teculután', value: '506'},
    {text: 'Municipalidad de Tejutla', value: '507'},
    {text: 'Municipalidad de Tiquisate', value: '508'},
    {text: 'Municipalidad de Todos Santos Cuchumatán', value: '509'},
    {text: 'Municipalidad de Totonicapán', value: '510'},
    {text: 'Municipalidad de Tucurú', value: '511'},
    {text: 'Municipalidad de Unión Cantinil', value: '512'},
    {text: 'Municipalidad de Uspantán', value: '513'},
    {text: 'Municipalidad de Usumatlán', value: '514'},
    {text: 'Municipalidad de Villa Canales', value: '515'},
    {text: 'Municipalidad de Villa Nueva', value: '516'},
    {text: 'Municipalidad de Yepocapa', value: '517'},
    {text: 'Municipalidad de Yupiltepeque', value: '518'},
    {text: 'Municipalidad de Zacapa', value: '519'},
    {text: 'Municipalidad de Zacualpa', value: '520'},
    {text: 'Municipalidad de Zapotitlán', value: '521'},
    {text: 'Municipalidad de Zaragoza', value: '522'},
    {text: 'Municipalidad de Zunil', value: '523'},
    {text: 'Municipalidad de Zunilito', value: '524'},
    {text: 'Oficina Asesora de Recursos Humanos de las Municipalidades (OARHM)', value: '525'},
    {text: 'Oficina Nacional de Servicio Civil (ONSEC)', value: '526'},
    {text: 'Organismo Judicial', value: '527'},
    {text: 'Otra', value: '528'},
    {text: 'Plan de Prestaciones del Empleado Municipal (PPEM)', value: '529'},
    {text: 'Presidencia de la República', value: '530'},
    {text: 'Procuraduría de los Derechos Humanos (PDH)', value: '531'},
    {text: 'Procuraduría General de la Nación (PGN)', value: '532'},
    {text: 'Registro de Información Catastral de Guatemala (RIC) ', value: '533'},
    {text: 'Registro General de la Propiedad (RGP)', value: '534'},
    {text: 'Registro Nacional de las Personas (Renap)', value: '535'},
    {text: 'Secretaria Contra la Violencia Sexual, Explotación y Trata de Personas', value: '536'},
    {text: 'Secretaría de Asuntos Agrarios de la Presidencia de la República (SAA)', value: '537'},
    {text: 'Secretaría de Bienestar Social de la Presidencia de la República (SBS)', value: '538'},
    {text: 'Secretaría de Comunicación Social de la Presidencia (SCSP)', value: '539'},
    {text: 'Secretaría de Coordinación Ejecutiva de la Presidencia (SCEP)', value: '540'},
    {text: 'Secretaria de Inteligencia Estratégica del Estado', value: '541'},
    {text: 'Secretaría de la Paz (SEPAZ)', value: '542'},
    {text: 'Secretaría de Obras Sociales de la Esposa del Presidente (SOSEP)', value: '543'},
    {text: 'Secretaría de Planificación y Programación de la Presidencia (Segeplán)', value: '544'},
    {text: 'Secretaría de Seguridad Alimentaria y Nutricional de la Presidencia de la Republica (SESAN)', value: '545'},
    {text: 'Secretaría Ejecutiva Comisión Contra las Adicciones y el Tráfico Ilícito de Drogas (SECATID)', value: '546'},
    {text: 'Secretaría Ejecutiva de la Instancia Coordinadora de la Modernización del Sector Justicia (SEICMJ)', value: '547'},
    {text: 'Secretaría General de la Presidencia de la República', value: '548'},
    {text: 'Secretaría Nacional de Administración de Bienes en Extinción de Dominio (Senabed)', value: '549'},
    {text: 'Secretaría Nacional de Ciencia y Tecnología', value: '550'},
    {text: 'Secretaría Presidencial de La Mujer (Seprem)', value: '551'},
    {text: 'Secretaría Privada de la Presidencia (SPP)', value: '552'},
    {text: 'Secretaría Técnica del Consejo Nacional de Seguridad', value: '553'},
    {text: 'Segundo Registro de la Propiedad', value: '554'},
    {text: 'Superintendencia de Administración Tributaria (SAT)', value: '555'},
    {text: 'Superintendencia de Bancos (SIB)', value: '556'},
    {text: 'Tribunal Electoral del Deporte Federado', value: '557'},
    {text: 'Tribunal Supremo Electoral (TSE)', value: '558'},
    {text: 'Universidad de San Carlos de Guatemala (USAC)', value: '559'},
    {text: 'Zona Libre de Industria y Comercio Santo Tomás de Castilla (Zolic)', value: '560'},
    {text: 'Comisión Presidencial de Gobierno Abierno y Electrónico', value: '561'},
    {text: 'Gobernación Departamental Petén', value: '562'},
    {text: 'Centro Médico Militar', value: '563'},
    {text: 'Vicepresidencia de la República', value: '564'},
    {text: 'Asociación Femenina para el Desarrollo de Sacatepéquez', value: '565'},
    {text: 'Colegio de Médicos y Cirujanos de Guatemala', value: '566'},
    {text: 'Consorcio RIADIS-Guatemala', value: '567'},
    {text: 'Colegio de Profesionales de Enfermería de Guatemala', value: '568'},
    {text: 'Mecanismo Nacional de Prevención de la Tortura', value: '569'},
    {text: 'Asociación Centro Internacional para Investigación en Derechos Humanos ONG', value: '570'},
    {text: 'Instituto Guatemalteco de Migración', value: '571'},
    {text: 'Comisión Portuaria Nacional', value: '572'},
    {text: 'Secretaría de Asuntos Administrativos y de Seguridad de la Presidencia', value: '573'},
    {text: 'Programa de Atención Movilización e Incidencia por la Niñez y Adolescencia PAMI', value: '574'}
]